import React from 'react';

const INTERVALS = Array.from({ length: 12 }, (_, index) => (index + 1) * 5);

export default function IntervalPicker({ value = 20, onChange, label }) {
  return (
    <div className="flex items-center gap-1 font-sans not-italic">
      {label && <span className="sr-only">{label}</span>}
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label={label || 'Foglalási időköz'}
        className="border-2 border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 dark:text-white rounded-xl p-3 font-black text-base outline-none"
      >
        {INTERVALS.map(minutes => <option key={minutes} value={minutes}>{minutes}</option>)}
      </select>
      <span className="font-black text-gray-400 dark:text-gray-500">perc</span>
    </div>
  );
}
